import React, { useState, useEffect } from 'react';
import { BadgePercent } from 'lucide-react';

function getNextSundayEnd() {
  const now = new Date();
  const d = new Date(now);
  d.setDate(now.getDate() + ((7 - now.getDay()) % 7));
  d.setHours(23, 59, 59, 999);
  if (d <= now) d.setDate(d.getDate() + 7);
  return d;
}

export default function CountdownBar() {
  const [remaining, setRemaining] = useState(0);

  useEffect(() => {
    const tick = () => setRemaining(Math.max(0, getNextSundayEnd() - Date.now()));
    tick();
    const t = setInterval(tick, 1000);
    return () => clearInterval(t);
  }, []);

  const total = Math.floor(remaining / 1000);
  const units = [
    { label: 'DAYS', value: Math.floor(total / 86400) },
    { label: 'HOURS', value: Math.floor((total % 86400) / 3600) },
    { label: 'MINS', value: Math.floor((total % 3600) / 60) },
    { label: 'SECS', value: total % 60 },
  ];

  return (
    <button
      type="button"
      onClick={() => document.getElementById('offer')?.scrollIntoView({ behavior: 'smooth' })}
      className="w-full bg-[#B7A47C] text-[#0B0B0B] cursor-pointer"
      data-testid="countdown-bar"
    >
      <div className="container mx-auto max-w-6xl px-6 py-4 flex flex-col sm:flex-row items-center justify-between gap-4">
        <div className="flex items-center gap-3">
          <BadgePercent className="w-6 h-6 shrink-0" />
          <div className="text-left">
            <div className="font-bold text-sm sm:text-base uppercase tracking-wide" style={{ fontFamily: 'Clash Display' }}>
              Limited Time Launch Offer
            </div>
            <div className="text-xs sm:text-sm text-[#0B0B0B]/70">Offer ends Sunday</div>
          </div>
        </div>
        <div className="flex items-center gap-2" data-testid="countdown-timer">
          {units.map((u) => (
            <div key={u.label} className="bg-[#F4EFE6] rounded-lg px-3 py-2 text-center min-w-[58px] shadow-sm">
              <div className="text-xl font-bold leading-none" style={{ fontFamily: 'Clash Display' }}>
                {String(u.value).padStart(2, '0')}
              </div>
              <div className="text-[10px] font-semibold tracking-widest mt-1 text-[#0B0B0B]/60">{u.label}</div>
            </div>
          ))}
        </div>
      </div>
    </button>
  );
}
